import { CART_MODULE } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
type InventoryTaxCreateAPIResponse = { status: boolean; message: string | null; surgePricesChanged?: boolean };

export interface ICouponCreationResponse {
  status: boolean;
  message: string;
  data: {
    coupon_id: string;
  };
}
export interface ICartCheckout {
  cart_id: string;
  clinic_id: string;
  paravet_id?: string;
  use_reward_credit?: boolean;
}

export const useCartCheckoutAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const dispatch = useAppDispatch();
  const { captureError, toastNotification } = useAPIUtils();
  const execute = useCallback(
    async (filterParams: ICartCheckout) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: InventoryTaxCreateAPIResponse = await axios
          .post(CART_MODULE?.CART_CHECKOUT?.baseURL ?? "", filterParams, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<ICouponCreationResponse>) => {
            if (res.data.status) {
              toastNotification(res.data.message);
              return { status: true, message: null };
            } else {
              return { status: false, message: null };
            }
          })
          .catch((e: AxiosError<{ data?: { surge_prices_changed?: boolean } }>) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);

            // Surge price moved since the cart was shown: caller reloads the cart before retrying.
            return { status: false, message: null, surgePricesChanged: !!e.response?.data?.data?.surge_prices_changed };
          });
        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { execute };
};
